(function () {
  'use strict';

  var rootSelector = '.trx-cart[data-trx-cart-ajax]';
  var pendingUpdates = Object.create(null);
  var updateTimer = 0;
  var requestChain = Promise.resolve();

  function currentRoot() {
    return document.querySelector(rootSelector);
  }

  function enhance(root) {
    if (root) root.classList.add('is-ajax-ready');
  }

  function setStatus(root, message, isError) {
    if (!root) return;
    var node = root.querySelector('[data-trx-cart-status]');
    if (!node) return;
    node.textContent = message || '';
    node.style.color = isError ? '#8b3d32' : '';
  }

  function setBusy(root, busy) {
    if (!root) return;
    root.classList.toggle('is-updating', !!busy);
    root.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function replaceCartSection(root, response) {
    if (!root || !response || !response.sections) return false;
    var sectionId = root.getAttribute('data-trx-cart-section');
    var html = response.sections[sectionId];
    if (!html) return false;

    var template = document.createElement('template');
    template.innerHTML = html.trim();
    var next = template.content.querySelector(rootSelector);
    if (!next) return false;

    root.replaceWith(next);
    enhance(next);
    return true;
  }

  function errorMessage(error) {
    if (!error) return 'We could not update your bag. Please try again.';
    if (typeof error === 'string') return error;
    if (error.description) return error.description;
    if (error.message) return error.message;
    return 'We could not update your bag. Please try again.';
  }

  function request(url, payload) {
    var root = currentRoot();
    if (!root) return Promise.resolve();

    var sectionId = root.getAttribute('data-trx-cart-section');
    payload.sections = [sectionId];
    payload.sections_url = window.location.pathname;
    setBusy(root, true);
    setStatus(root, 'Updating bag…', false);

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    }).then(function (data) {
      var beforeReplace = currentRoot();
      if (!replaceCartSection(beforeReplace, data)) window.location.reload();
      document.dispatchEvent(new CustomEvent('tailroad:cart-updated', { detail: data }));
    }).catch(function (error) {
      var failedRoot = currentRoot();
      if (failedRoot) {
        failedRoot.classList.remove('is-ajax-ready');
        setStatus(failedRoot, errorMessage(error), true);
      }
      throw error;
    }).finally(function () {
      setBusy(currentRoot(), false);
    });
  }

  function enqueue(task) {
    requestChain = requestChain.then(task, task).catch(function () {
      return undefined;
    });
    return requestChain;
  }

  function flushPending() {
    window.clearTimeout(updateTimer);
    updateTimer = 0;
    var keys = Object.keys(pendingUpdates);
    if (!keys.length) return;

    var updates = pendingUpdates;
    pendingUpdates = Object.create(null);

    enqueue(function () {
      var root = currentRoot();
      if (!root) return Promise.resolve();
      return request(root.getAttribute('data-trx-cart-update-url'), { updates: updates });
    });
  }

  function schedulePending() {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(flushPending, 180);
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-trx-cart-qty]');
    if (!input) return;
    var root = input.closest(rootSelector);
    if (!root) return;

    var key = input.getAttribute('data-trx-cart-key');
    var quantity = parseInt(input.value || '0', 10);
    if (!key || Number.isNaN(quantity)) return;
    quantity = Math.max(0, quantity);
    input.value = quantity;
    pendingUpdates[key] = quantity;
    schedulePending();
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest && event.target.closest('[data-trx-cart-remove]');
    if (remove) {
      var removeRoot = remove.closest(rootSelector);
      if (!removeRoot) return;
      event.preventDefault();
      var removeKey = remove.getAttribute('data-trx-cart-key');
      if (!removeKey) return;
      pendingUpdates[removeKey] = 0;
      flushPending();
      return;
    }

    var add = event.target.closest && event.target.closest('[data-trx-cross-add]');
    if (!add) return;
    var addRoot = add.closest(rootSelector);
    if (!addRoot) return;
    event.preventDefault();

    var variantId = parseInt(add.getAttribute('data-variant-id') || '0', 10);
    if (!variantId) return;

    flushPending();
    enqueue(function () {
      var root = currentRoot();
      if (!root) return Promise.resolve();
      return request(root.getAttribute('data-trx-cart-add-url'), {
        items: [{ id: variantId, quantity: 1 }]
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhance(currentRoot()); });
  } else {
    enhance(currentRoot());
  }
})();
